module.exports = __webpack_public_path__ + "static/media/checkbox_inactive.dfecbc00.svg";